/**
 * Capitalize string (first letter uppercase)
 * @returns {string} Capitalized string
 */
String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

/**
 * Replace url-safe characters with their representations
 * @returns {string} String with replaced characters
 */
String.prototype.replaceAmpGtLt = function() {
    return this
        .replace(/&amp;/g, '&')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
}

/**
 * Remove any dot characters '.' if present at end of string
 * @returns {string} String with removed dot characters from end
 */
String.prototype.removeDotsAtEnd = function() {
    return this.replace(/[. ]*$/, '')
}
